define('view/form/base.finder.content.view',['require','exports','module','underscore','backbone','uikit/uikit','formkit/view/form.object/content/base.content.view','../finder/external.org.finder.view','backbone.radio'],function(require, exports, module) {
  //prettier-ignore
  var _                     = require('underscore'),
      Backbone              = require('backbone'),
      UIKit                 = require('uikit/uikit'),
      BaseContentView       = require('formkit/view/form.object/content/base.content.view'),
      ExternalOrgFinderView = require('../finder/external.org.finder.view'),
      Radio                 = require('backbone.radio');
      disclosureChangeChannel  = Radio.channel('disclosureChangeChannel');

  var PreviewAnswerInsideTableEmptyView = UIKit.ItemView.extend({
    template: function() {
      return '<ui name="emptyTextView"/> <ui name="findButtonView" />';
    },

    options: {
      parentView: null,
    },

    internalViewOptions: {
      emptyTextView: {
        type: UIKit.Text,
        text: 'No record selected.',
      },
      findButtonView: function() {
        return {
          type: UIKit.Button,
          inline: true,
          link: true,
          text: 'Find record.',
          color: 'blue',
          visible: !this.getOption('readonly'),
        };
      },
    },

    onInjectedFindButtonView: function() {
      var self = this;
      this.listenTo(this.parentView, 'change:readonly', function(name) {
        self.readonly = this.parentView.getOption('readonly');
      });
    },

    onChangeReadonly: function() {
      this.findButtonView.visible = !this.getOption('readonly');
    },

    onFindButtonViewPress: function() {
      if (this.parentView) {
        this.parentView.triggerMethod('finder:templateObject');
      }
    },
  });

  var PreviewAnswerInsideTableView = UIKit.ItemView.extend({
    template: function() {
      return '<ui name="finderTableView" />';
    },

    options: {
      type: '',
      modalHeaderText: '',
      finderEmptyView: PreviewAnswerInsideTableEmptyView,
    },

    internalViewOptions: {
      finderTableView: function() {
        return {
          type: UIKit.Table.extend({
            emptyView: this.getOption('finderEmptyView'),
            childView: ExternalOrgFinderView.SelectedTableRowView,
            emptyViewOptions: {
              parentView: this,
              readonly: this.getOption('readonly'),
            },
          }),
          basic: true,
          borderless: true,
          headless: true,
          columns: [],
          collection: this.getSelectedCollectionFromAnswerValueModel(),
        };
      },
    },

    internalViewBindings: {
      finderTableView: {
        readonly: 'readonly',
      },
    },

    onInjectedFinderTableView: function() {
      var self = this;
      var removeButtonColumn = {
        collapsing: true,
        childView: UIKit.Button.extend({
          className: UIKit.Button.prototype.className + ' icon',
          attributes: { style: 'white-space: nowrap;' },
        }),
        childViewOptions: {
          icon: 'remove',
          color: 'blue',
          text: 'clear',
          inline: true,
        },
        // this function call is triggered from OrgFinder at SFI
        onBeforeAdd: function(childView) {
          childView.on('press', function() {
            console.log('Trigger remove from CLEAR button childView.model:');
            console.log(childView.model);

            // COI-1981: remove ExtOrg.
            var orgModel = new ProvisionalOrganizationModel(childView.model.attributes);
            disclosureChangeChannel.trigger('external-org-finder:extorg-removed', orgModel);
            ///////////

            console.log('Call removeRowFromAnswerDisplay from CLEAR button');
            self.removeRowFromAnswerDisplayAndAnswerValueCollection(childView.model);

          });

          childView.listenTo(self, 'change:readonly', function() {
            childView.disabled = self.getOption('readonly');
          });

          childView.disabled = self.getOption('readonly');
        },
      };

      this.finderTableView.columns.add(removeButtonColumn);
    },

    removeRowFromAnswerDisplayAndAnswerValueCollection: function(model) {
      var self = this;

      _.defer(function() {
        var answerValueModel = self.form.getAnswerValueModel(self.model, self.getAnswerValueIndex());
        answerValueModel.set('value', null);

        self.finderTableView.collection.remove(model);

        self.form.triggerBeginEditAnswerEvent(self, self.model, {
          answerValueModel: answerValueModel,
        });
        self.form.triggerEndEditAnswerEvent(self, self.model, {
          answerValueModel: answerValueModel,
        });
      });
    },

    onFinderTemplateObject: function() {
      var selectedCollection = this.getSelectedCollectionFromAnswerValueModel().clone();
      var typeColumnData = this.getOption('typeColumnData');
      var headerText = this.getOption('modalHeaderText');

      var modalFinderOptions = _.extend(
        {
          selectedCollection: selectedCollection,
          typeColumnData: typeColumnData,
          headerText: headerText,
          maxAnswerMultiplicity: 1,
          updateView: this,
        },
        this.getOption('modalFinderOptions')
      );

      Radio.channel('finderService').request('open', this.getOption('type'), modalFinderOptions);
    },

    updateAnswerDisplayAndAnswerValueCollection: function(selectedCollection) {
      var answerValueModel = this.getAndLinkAnswerValueModel(this.model, this.form);

      // set value back to the first model in selected collection
      answerValueModel.set('value', selectedCollection.at(0));

      this.finderTableView.collection.set(selectedCollection.models);

      this.form.triggerBeginEditAnswerEvent(this, this.model, {
        answerValueModel: answerValueModel,
      });
      this.form.triggerEndEditAnswerEvent(this, this.model, {
        answerValueModel: answerValueModel,
      });
    },

    updateAnswerValueCollectionFromSelectedCollection: function(selectedCollection) {
      this.updateAnswerDisplayAndAnswerValueCollection(selectedCollection);
    },

    // there will always be only 1 item inside selected collection, which corresponds to the row number
    getSelectedCollectionFromAnswerValueModel: function() {
      var answerValueModel = this.getAndLinkAnswerValueModel(this.model, this.form);
      var value = answerValueModel.get('value');

      // values will be empty if corresponding row value is null
      var values = value ? [value] : [];

      return new Backbone.Collection(values, { model: this.getOption('modelClass') || Backbone.Model });
    },

    // this function must be used to get answers when component is potentially to be used inside table
    // see table content view to see the overriden version of this function
    getAndLinkAnswerValueModel: function(model, form) {
      var defaultAnswerIndex = this.getAnswerValueIndex();
      return form.getAnswerValueModel(model, defaultAnswerIndex);
    },
    getAnswerValueIndex: function() {
      return 0;
    },
  });

  var PreviewAnswerView = UIKit.ItemView.extend({
    template: function() {
      return '<ui name="finderTableView" /><ui name="addButtonView" />';
    },

    options: {
      type: '',
      modalHeaderText: '',
      finderChildView: UIKit.Table.RowView,
    },

    internalViewOptions: {
      finderTableView: function() {
        return {
          type: UIKit.Table,
          childView: this.getOption('finderChildView'),
          unstackable: !this.getOption('editable'),
        };
      },
      addButtonView: function() {
        return {
          type: UIKit.Button,
          color: 'primary',
          icon: 'search',
          size: 'small',
        };
      },
    },

    internalViewBindings: {
      finderTableView: {
        readonly: 'readonly',
      },
    },

    initialize: function() {
      UIKit.ItemView.prototype.initialize.apply(this, arguments);

      this.templateObjectTypeModel = this.form.getTemplateObjectType(this.model);
      this.answerValueCollection = this.form.getAnswerValueCollection(this.model);
      this.answerDisplayCollection = this.getSelectedCollectionFromAnswerValueCollection();
      this.finderTableView.collection = this.answerDisplayCollection;

      this.addButtonView.disabled = this.toggleAddButtonDisableProperty();
      this.listenTo(this.answerDisplayCollection, 'add remove', function() {
        this.addButtonView.disabled = this.toggleAddButtonDisableProperty();
      });
    },

    onFirstRender: function() {
      this.listenTo(this.answerValueCollection, 'remove', function(removedAnswerValueModel, collection, options) {
        this.answerDisplayCollection.remove(removedAnswerValueModel.get('value'), options);

        if (_.result(options, 'isFromServer')) {
          return;
        }

        this.form.triggerBeginEditAnswerEvent(this.addButtonView, this.model, {
          answerValueModel: removedAnswerValueModel,
        });
        this.form.triggerEndEditAnswerEvent(this.addButtonView, this.model, {
          answerValueModel: removedAnswerValueModel,
        });
      });

      this.listenTo(this.answerValueCollection, 'add', function(addedAnswerValueModel, collection, options) {
        this.answerDisplayCollection.add(addedAnswerValueModel.get('value'), options);

        if (_.result(options, 'isFromServer')) {
          return;
        }

        this.form.triggerBeginEditAnswerEvent(this.addButtonView, this.model, {
          answerValueModel: addedAnswerValueModel,
        });
        this.form.triggerEndEditAnswerEvent(this.addButtonView, this.model, {
          answerValueModel: addedAnswerValueModel,
        });
      });
    },

    toggleAddButtonDisableProperty: function() {
      var disableAddButtonFlag =
        this.templateObjectTypeModel.get('maxAnswerMultiplicity') === this.answerDisplayCollection.length ||
        this.getOption('readonly')
          ? true
          : false;

      return disableAddButtonFlag;
    },

    onInjectedFinderTableView: function() {
      var self = this;
      var removeButtonColumn = {
        collapsing: true,
        childView: UIKit.Button,
        childViewOptions: {
          icon: 'remove',
          inline: true,
          color: 'red',
          disabled: this.getOption('readonly'),
        },
          // this function call is triggered from stand alone OrgFinder
        onBeforeAdd: function(childView) {
          childView.on('press', function() {

            // COI-1981 remove entry from ExtOrg finder. It seems that this function is used by PersonFinder too
            if(!childView.model.get('fullName')) {// ALWAYS exists only at Person model
              disclosureChangeChannel.trigger('external-org-finder:extorg-removed', childView.model);
            }

            self.removeRowFromAnswerDisplayAndAnswerValueCollection(childView.model);
          });


          childView.listenTo(self, 'change:readonly', function() {
            childView.disabled = self.getOption('readonly');
          });
        },
      };


      this.finderTableView.columns.add(removeButtonColumn);
    },

    onFinderTemplateObject: function() {
      var selectedCollection = this.answerDisplayCollection.clone();
      var typeColumnData = this.getOption('typeColumnData');
      var headerText = this.getOption('modalHeaderText');
      var maxAnswerMultiplicity = this.templateObjectTypeModel.get('maxAnswerMultiplicity');

      var modalFinderOptions = _.extend(
        {
          selectedCollection: selectedCollection,
          typeColumnData: typeColumnData,
          headerText: headerText,
          updateView: this,
          maxAnswerMultiplicity: maxAnswerMultiplicity,
        },
        this.getOption('modalFinderOptions')
      );

      Radio.channel('finderService').request('open', this.getOption('type'), modalFinderOptions);
    },

    getSelectedCollectionFromAnswerValueCollection: function() {
      var values = this.answerValueCollection.pluck('value');

      return new Backbone.Collection(values, { model: this.getOption('modelClass') || Backbone.Model });
    },

    updateAnswerValueCollectionFromSelectedCollection: function(selectedCollection) {
      this.answerValueCollection.set(
        selectedCollection.map(function(selectedModel) {
          return { id: selectedModel.id, value: selectedModel };
        })
      );
    },

    removeRowFromAnswerDisplayAndAnswerValueCollection: function(model) {
      var self = this;

      _.defer(function() {
        self.answerDisplayCollection.remove(model);
        self.answerValueCollection.remove(model);
      });
    },

    onAddButtonViewPress: function() {
      this.triggerMethod('finder:templateObject', this.model);
    },

    onFinderTableViewRowAddItem: function() {
      this.triggerMethod('finder:templateObject', this.model);
    },
  });

  var BaseFinderContentView = BaseContentView.extend({
    internalViewOptions: BaseContentView.extendInternalViewOptions({
      previewAnswerView: function() {
        return {
          type: PreviewAnswerView,
          model: this.model,
        };
      },
    }),
  });

  BaseFinderContentView.PreviewAnswerView = PreviewAnswerView;
  BaseFinderContentView.PreviewAnswerInsideTableView = PreviewAnswerInsideTableView;
  BaseFinderContentView.PreviewAnswerInsideTableEmptyView = PreviewAnswerInsideTableEmptyView;
  module.exports = BaseFinderContentView;
});

